import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function ReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      // Stocker le code de parrainage dans le localStorage
      localStorage.setItem('referral_code', code);
      // Rediriger vers la page d'inscription
      navigate('/register');
    }
  }, [code, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <p className="text-white">Redirection en cours...</p>
    </div>
  );
} 